import {definePreset} from "@primeng/themes";
import Lara from "@primeng/themes/lara";

export const BsPreset = definePreset(Lara, {
    primitive: {
      // zinc: {
      // 0: '#ffffff',
      // 50: '#f8fafc',
      // 100: '#f1f5f9',
      // 200: '#e2e8f0',
      // 300: '#cbd5e1',
      // 400: '#94a3b8',
      // 500: '#64748b',
      // 600: '#475569',
      // 700: '#334155',
      // 800: '#1e293b',
      // 900: '#0f172a',
      // 950: '#020617',
      // },
    },
    semantic: {
      primary: {
        50: '{blue.50}',
        100: '{blue.100}',
        200: '{blue.200}',
        300: '{blue.300}',
        400: '{blue.400}',
        500: '{blue.500}',
        600: '{blue.600}',
        700: '{blue.700}',
        800: '{blue.800}',
        900: '{blue.900}',
        950: '{blue.950}',
      },
    },
    extend: {
      colorScheme: {
        light: {
            bs: {
              menucolor: '#f7f7f7',
              icon: {
                color: '#000000'
              },
              viewer: {
                sidebar: {
                  background: 'hsl(220, 100%, 98.824%)',
                }
              },
              globalsearch: {
                menucolor: '#f7f7f7',
                iconcolor: '#000000'
              },
              topnav: {
                boxshadow: '0 0 1px 1px rgb(0 0 0/5%),0 1px 2px -2px rgb(0 0 0/6%),0 1px 3px 0 rgb(0 0 0/7%)'
              },
              dashboard: {
                statistics:{
                  background: '#f7f7f7'
                }
              }
            }
        },
        dark: {
            bs: {
              menucolor: '#151515',
              icon: {
                color: '#ffffff'
              },
              viewer: {
                sidebar: {
                  background: 'hsl(226.667, 14.286%, 12.353%)',
                }
              },
              globalsearch: {
                menucolor: '#151515',
                iconcolor: '#fff'
              },
              topnav: {
                boxshadow: '0 0 1px 1px rgb(173 173 173 / 5%), 0 1px 2px -2px rgb(173 173 173 / 6%), 0 1px 3px 0 rgb(173 173 173 / 7%)'
              },
              dashboard: {
                statistics:{
                  background: '#000000'
                }
              }
          }
        }
      },
      bs: {
          icon: {
            size: '40px',
          },
          sidenav: {
            backgroundcolor: '#0E2954',
            hoverbackgroundcolor: '#2a497c',
            selectedbackgroundcolor: '#1f3f77',

            iconcolor: '#fff',
            iconsize: '30px',
            svgiconsize: '30',
            width: '60px'
          },
          topnav: {
            height: '52px',
          }
      }
    },
    components: {
      card: {
        body: {
          padding: '0em 1em 1em 1em',

        }
      },
      datatable: {
        header: {
          padding: '1em 1em 1em 1em'
        },
        headerCell: {
          padding: '1em 1em 1em 1em'
        },
        bodyCell: {
          padding: '.2em 1em .2em .5em'
        },
        colorScheme: {
          dark: {
            headerCell: {
              selectedBackground: '#1f2d44'
            }
          }
        }
      },
      menubar: {
        root: {
          padding: '0'
        }
      },
    }
  }
);
